<template>
    <BreadCrumb PageTitle="Détails partenaires" />
    <ViewPartenaire />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";

import ViewPartenaire from "@/components/Partenaires/ViewPartenaire.vue";

export default defineComponent({
    name: "ViewPartenairePage",
    components: {
        BreadCrumb,
        ViewPartenaire,
    },
});
</script>